import { Box, Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import time from '../../assets/icons/bx_time.png';
import courseLogo from '../../assets/icons/idea.png';
import koins from '../../assets/icons/kcoin.png';
import cardDisabled from '../../assets/img/card-disabled.PNG';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '12px',
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    background: theme.palette.background.card,
    color: theme.palette.common.white,
    margin: theme.spacing(0, 7),
    padding: theme.spacing(4, 4),
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(0, 3),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 6),
    },
  },
  statusCard: {
    maxWidth: '20%',
    textAlign: 'center',
    borderRadius: '8px',
    background: theme.palette.background.info,
    color: theme.palette.common.black,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
    zIndex: 0,
  },
  infoItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  font: {
    fontFamily: 'Raleway',
  },
  fontTitle: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    fontWeight: '700',
  },
  img: {
    marginRight: theme.spacing(1),
  },
  cardAction: {
    display: 'flex',
    justifyContent: 'center',
  },
  disableCard: {
    position: 'absolute',
    backdropFilter: 'blur(4px)',
    borderRadius: '12px',
    margin: theme.spacing(0, 6),
    background: '#0f101150',
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(0, 3),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 6),
    },
  },
  textDisable: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    fontFamily: 'Raleway',
    fontWeight: 700,
    color: theme.palette.text.default,
    minWidth: 394,
    minHeight: 588,
  },
}));

function DisableCard({
  title, shortDescription, kcoins, duration,
}) {
  const classes = useStyles();
  const cardDescription = `${shortDescription.slice(0, 175)}...`;
  return (
    <Grid>
      <Grid className={classes.disableCard}><Typography align="center" className={classes.textDisable}>MUY PRONTO</Typography></Grid>
      <Card className={classes.card}>
        <Box>
          <Box>
            <Typography className={classes.statusCard}>Nuevo</Typography>
          </Box>
          <Box className={classes.title}>
            <Box>
              <Typography className={classes.fontTitle} variant="h5">{title}</Typography>
              <Typography className={classes.font}>Curso</Typography>
            </Box>
            <img src={courseLogo} alt="course" />
          </Box>
          <Box>
            <Typography variant="body2" className={classes.font}>
              {cardDescription}
            </Typography>
          </Box>
          <Box className={classes.info}>
            <Box className={classes.infoItems}>
              <img alt="time" className={classes.img} src={time} />
              <Typography variant="body2" className={classes.font}>{`${duration}`}</Typography>
            </Box>
            <Box className={classes.infoItems}>
              <img alt="kcoins" className={classes.img} src={koins} />
              <Typography variant="body2" className={classes.font}>{`${kcoins} kcoins`}</Typography>
            </Box>
          </Box>
          <img alt="time" className={classes.img} src={cardDisabled} />
        </Box>
      </Card>
    </Grid>
  );
}

DisableCard.propTypes = {
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  kcoins: PropTypes.number.isRequired,
};

export default DisableCard;
